@if (hasFinanceAccess() && logs().length) {
  <span (click)="openDialog()" class="hover:cursor-pointer">
    <p-overlaybadge [value]="logs().length" severity="danger">
      <elcia-icon [iconSize]="'3xl'" [iconType]="'warning'" class="text-red-500"/>
    </p-overlaybadge>
  </span>
}

@if (isDialogDisplayed()) {
  <elcia-dialog
    (onAction)="resolveAll()"
    (onClose)="closeDialog()"
    [actionIcon]="'check'"
    [actionLabel]="'action.resolve-all' | translate"
    [size]="'x-small'"
    [title]="'invoicing-log.title' | translate"
  >
    <div class="flex flex-col gap-2">
      @for (log of logs(); track log.id) {
        <!-- Severity indicator dot + animation matching the notification-item design -->
        <div [animate.enter]="'notification-enter'"
             class="notification-enter px-4 py-3 bg-primary-50 rounded-xl flex justify-between items-start gap-3">
          <!-- Left: severity dot -->
          <span
            class="mt-1 shrink-0 size-2 rounded-full"
            [class]="log.level === LogLevel.ERROR ? 'bg-red-500' : 'bg-orange-400'"
          ></span>

          <!-- Center: header (date + customer) + message -->
          <div class="flex-1 min-w-0">
            <label class="flex flex-wrap items-baseline gap-x-1 text-xs text-primary-400 font-normal">
              <span>{{ log.date | date:'dd/MM/yyyy HH:mm' }}</span>
              @if (log.customerName) {
                <span class="text-primary-700 font-medium">— {{ log.customerName }}</span>
              }
            </label>
            <div
              class="mt-0.5 text-sm break-words"
              [class]="log.level === LogLevel.ERROR ? 'text-red-600' : 'text-orange-500'"
            >
              {{ log.message }}
            </div>
          </div>

          <!-- Right: action buttons -->
          <div class="flex gap-1 shrink-0">
            <elcia-button (onClick)="resolve(log)" [icon]="'check'" [size]="'small'" [variant]="'text'"/>
            
          </div>
        </div>
      }
    </div>
  </elcia-dialog>
}
